import { FC } from 'react';
import { Alert as MuiAlert, AlertTitle as MuiAlertTitle } from '@mui/material';

import type { AlertProps as MuiAlertProps, SxProps } from '@mui/material';
import type { ReactNode } from 'react';

type AlertProps = {
  children: ReactNode;
  title?: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
  sx?: SxProps;
};

const Alert: FC<AlertProps & Omit<MuiAlertProps, 'severity'>> = ({
  title,
  children,
  sx,
  ...rest
}) => {
  const mergedStyles = {
    ...(typeof sx === 'object' ? sx : {}),
    ...styles.alertBody,
  };

  return (
    <MuiAlert sx={mergedStyles} {...rest}>
      {title && <MuiAlertTitle>{title}</MuiAlertTitle>}
      {children}
    </MuiAlert>
  );
};

const styles = {
  alertBody: {
    boxShadow: 1,
  },
};

export { Alert };
